import * as arise from '@/arise/api';
import { Profile, ProfileAssetType, Rarity, Title } from '@/models/profile';
import { msTimeDifferenceFromNow } from './time';
import { pathToURL } from './urls';

// TODO: remove pathToURL once backend supplies urls.
export function processProfileData(profile: Profile) {
    return {
        ...profile,
        factionImageUrl: pathToURL(profile.faction.imagePath),
        faction: {
            ...profile.faction,
            iconImageUrl: pathToURL(profile.faction.iconPath),
        },
        isBanned: profile.bannedUntil && msTimeDifferenceFromNow(profile.bannedUntil) > 0,
    };
}

export function processTitles(titles: Title[]): Title[] {
    if (!titles.length) return [];

    // Remove duplicates based on the title property
    const uniqueTitlesMap = new Map<string, Title>();
    titles?.forEach((title) => {
        uniqueTitlesMap.set(title.title, title);
    });

    // Convert the map back to an array
    const uniqueTitles = Array.from(uniqueTitlesMap.values());

    // Define the order of rarities
    const rarityOrder: Record<Rarity, number> = {
        common: 1,
        uncommon: 2,
        rare: 3,
        epic: 4,
        legendary: 5,
    };

    // Sort the unique titles based on the rarity order (case-insensitive)
    uniqueTitles.sort((a, b) => {
        const rarityA = rarityOrder[a.rarity.toLowerCase()] || 0;
        const rarityB = rarityOrder[b.rarity.toLowerCase()] || 0;
        return rarityA - rarityB;
    });

    return uniqueTitles;
}

export async function setProfileAsset(type: ProfileAssetType, itemId: string): Promise<boolean> {
    let wasSuccessful = false;
    try {
        await arise.setUserCurrentAsset(type, itemId);
        wasSuccessful = true;
    } catch (error) {
        console.warn(`Could not set user asset: ${type + ' ' + itemId}, ${error}`);
    }
    return wasSuccessful;
}

export async function unsetProfileAsset(type: ProfileAssetType) {
    try {
        await arise.unsetUserCurrentAsset(type);
    } catch (error) {
        console.warn(`Could not unset user asset type: ${type}, ${error}`);
    }
}

export async function setProfileTitle(id: string): Promise<boolean> {
    let wasSuccessful = false;
    try {
        await arise.setProfileTitle(id);
        wasSuccessful = true;
    } catch (error) {
        console.warn(`Could not set user title: ${id}, ${error}`);
    }
    return wasSuccessful;
}

export function profileHasOnboarded(profile: Profile) {
    return profile && profile?.background && profile?.character && profile?.faction;
}
